import { type ViewData, type ViewListInput, type ViewListSuccess, type ViewSurface } from '@terros/common'
import { useTantalimQuery } from '../query'
import { type GetHookResponse } from '../hooks'
import { viewListKey } from './keys'

export function useViews(surface: ViewSurface): GetHookResponse<ViewData[]> {
  return useTantalimQuery<ViewListInput, ViewListSuccess, ViewData[]>({
    url: '/view/list',
    queryKey: viewListKey(surface),
    input: { surface },
    convertResponse: ({ views }) => views,
  })
}
